import React from "react";
import { SEO, MainLayout, PaymentMethod } from "../../../components";

const PaymentMethodPage = () => {
  return (
    <>
      <SEO title="payment method" />
      <MainLayout>
        <PaymentMethod />
      </MainLayout>
    </>
  );
};

export default PaymentMethodPage;
